import React from 'react';

type Props = {
  activeStep: number;
  numOfSteps: number;
  title: string;
  nextStep?: string;
};

const FormHeader: React.FC<Props> = ({
  activeStep,
  numOfSteps,
  title,
  nextStep,
}) => {
  return (
    <div className="FormHeader">
      <h3>
        Step {activeStep} of {numOfSteps}
      </h3>
      <h1>{title}</h1>
      {nextStep && <p>Next: {nextStep}</p>}
    </div>
  );
};

export default FormHeader;
